export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BrandsHighlight.vue?vue&type=template&id=870693ba&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/BrandsHighlight.vue?vue&type=template&id=870693ba&scoped=true
// module id = 229
// module chunks = 0